import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { TicketsModule } from '@features/tickets/tickets.module';
import { TelekomSharedModule } from '@mandants/telekom/telekom-shared.module';
import { FORMLY_CONFIG } from '@ngx-formly/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CustomSliderComponent } from '@shared/components/custom-slider/custom-slider.component';
import { SharedModule } from '@shared/shared.module';
import { registerTranslateExtension } from '@shared/utils/translate.extension';
import { defineCustomElements } from '@telekom/scale-components/loader';
import { ImpressumComponent } from 'src/mandants/telekom/features/rem/pages/impressum/impressum.component';
import { AnimatedCounterComponent } from './components/animated-counter/animated-counter.component';
import { ButtonWrapperComponent } from './components/button-wrapper/button-wrapper.component';
import { ContactComponent } from './pages/contact/contact.component';
import { HomeComponent } from './pages/home/home.component';
import { LoginServiceProviderComponent } from './pages/login-service-provider/login-service-provider.component';
import { ExternalPartnerIdentificationComponent } from './pages/external-partner-identification/external-partner-identification.component';
import { MaintenanceComponent } from './pages/maintenance/maintenance.component';
import { PodcastComponent } from './pages/podcast/podcast.component';
import { PortfolioComponent } from './pages/portfolio/portfolio.component';
import { StatusItemComponent } from './pages/status/status-item.component';
import { StatusComponent } from './pages/status/status.component';
import { WhoComponent } from './pages/who/who.component';
import { RemComponent } from './rem.component';
import { BodyComponent } from './widgets/body/body.component';
import { ColumnContainerComponent } from './widgets/column-container/column-container.component';
import { ContactCardComponent } from './widgets/contact-card/contact-card.component';
import { FactItemComponent } from './widgets/fact/fact-item/fact-item.component';
import { FactWrapperHomePageComponent } from './widgets/fact/fact-wrapper-home-page/fact-wrapper-home-page.component';
import { FactWrapperComponent } from './widgets/fact/fact-wrapper/fact-wrapper.component';
import { FaqItemComponent } from './widgets/faq/faq-item/faq-item.component';
import { FaqWrapperComponent } from './widgets/faq/faq-wrapper/faq-wrapper.component';
import { FooterComponent } from './widgets/footer/footer.component';
import { HeaderContentAreaComponent } from './widgets/header-content-area/header-content-area.component';
import { HeaderComponent } from './widgets/header/header.component';
import { OurChallengesComponent } from './widgets/our-challenges/our-challenges.component';
import { OurTasksComponent } from './widgets/our-tasks/our-tasks.component';
import { QuickTextComponent } from './widgets/quick-text/quick-text.component';
import { RentalItemDetailsComponent } from './widgets/rental-search/rental-item-details/rental-item-details.component';
import { RentalItemComponent } from './widgets/rental-search/rental-item/rental-item.component';
import { RentalSearchComponent } from './widgets/rental-search/rental-search.component';
import { SalesItemDetailsComponent } from './widgets/sell-search/sales-item-details/sales-item-details.component';
import { SalesItemComponent } from './widgets/sell-search/sales-item/sales-item.component';
import { SalesSearchComponent } from './widgets/sell-search/sales-search.component';
import { ThumbnailComponent } from './widgets/thumbnail/thumbnail.component';

defineCustomElements();

@NgModule({
  declarations: [
    RemComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    PortfolioComponent,
    ContactComponent,
    BodyComponent,
    ThumbnailComponent,
    FaqWrapperComponent,
    FaqItemComponent,
    FactWrapperComponent,
    FactWrapperHomePageComponent,
    FactItemComponent,
    AnimatedCounterComponent,
    ButtonWrapperComponent,
    QuickTextComponent,
    ColumnContainerComponent,
    WhoComponent,
    ContactCardComponent,
    ImpressumComponent,
    PodcastComponent,
    OurChallengesComponent,
    OurTasksComponent,
    StatusComponent,
    StatusItemComponent,
    MaintenanceComponent,
    HeaderContentAreaComponent,
    RentalSearchComponent,
    RentalItemComponent,
    RentalItemDetailsComponent,
    SalesSearchComponent,
    SalesItemDetailsComponent,
    SalesItemComponent,
    LoginServiceProviderComponent,
    ExternalPartnerIdentificationComponent
  ],
  imports: [
    TelekomSharedModule,
    SharedModule,
    TranslateModule,
    TicketsModule,
    CustomSliderComponent,
  ],
  exports: [
    RemComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    PortfolioComponent,
    ContactComponent,
    BodyComponent,
    ThumbnailComponent,
    FaqWrapperComponent,
    FaqItemComponent,
    FactWrapperComponent,
    FactWrapperHomePageComponent,
    FactItemComponent,
    AnimatedCounterComponent,
    ButtonWrapperComponent,
    QuickTextComponent,
    WhoComponent,
    ContactCardComponent,
    PodcastComponent,
    OurChallengesComponent,
    OurTasksComponent,
    HeaderContentAreaComponent,
    RentalSearchComponent,
    RentalItemComponent,
    RentalItemDetailsComponent,
    SalesSearchComponent,
    SalesItemDetailsComponent,
    SalesItemComponent,
    LoginServiceProviderComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: FORMLY_CONFIG,
      multi: true,
      useFactory: registerTranslateExtension,
      deps: [TranslateService],
    },
  ],
})
export class TelekomRemModule {}
